// import axios from "axios";

// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const api = axios.create({
//   baseURL: API_BASE,
//   // headers: { "Content-Type": "application/json" }
// });

// // attach token automatically if available
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// export default api;

































import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_BASE,
});

// Attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/* ---------------- AUTH API FUNCTIONS ---------------- */

// Register
export const registerUser = (data) =>
  api.post("/auth/register", data);

// Login
export const loginUser = (data) =>
  api.post("/auth/login", data);

// Verify Email
export const verifyEmail = (token) =>
  api.get(`/auth/verify-email?token=${token}`);

// Resend Verification Email
export const resendVerification = (email) =>
  api.post("/auth/resend-verification", { email });

// Forgot Password
export const forgotPassword = (email) =>
  api.post("/auth/forgot-password", { email });

// Reset Password
export const resetPassword = (data) =>
  api.post("/auth/reset-password", data);

/* ---------------------------------------------------- */

export default api;
